module.exports = __webpack_public_path__ + "img/edit-icon-grey.c9cde661.svg";